export const possibleOptions = [
    { label: "Mililitros", value: "volume-mililitros" },
    { label: "Litros", value: "volume-litros" },
    { label: "Gramas", value: "peso-gramas" },
    { label: "Quilos", value: "peso-quilo" },
    { label: "Centimetros", value: "comprimento-centimetros" },
    { label: "Metros", value: "comprimento-metros" },
    { label: "Unidades", value: "unidades" },
  ];